
document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(
      '.timeline-vertical-v1[data-wp-interactive="core/accordion"]'
    )
    .forEach((accordion) => {

      // autoclose runtime me false
      try {
        const ctx = JSON.parse(accordion.getAttribute("data-wp-context"));
        ctx.autoclose = false;
        accordion.setAttribute("data-wp-context", JSON.stringify(ctx));
      } catch (e) { }

      // WP init ke baad
      setTimeout(() => {
        accordion
          .querySelectorAll(".wp-block-accordion-item")
          .forEach((item) => {

            const btn = item.querySelector(".wp-block-accordion-heading__toggle");
            const panel = item.querySelector(".wp-block-accordion-panel");

            if (!btn || !panel) return;

            // ensure open
            if (btn.getAttribute("aria-expanded") === "false") {
              btn.click();
            }

            // HARD DISABLE
            btn.setAttribute("aria-expanded", "true");
            btn.setAttribute("tabindex", "-1");
            btn.setAttribute("aria-disabled", "true");

            btn.style.pointerEvents = "none";
            btn.style.cursor = "default";

            btn.addEventListener(
              "keydown",
              (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
              },
              true
            );
          });
      }, 300);
    });
});

(() => {
  document
    .querySelectorAll(".wp-block-accordion.timeline-vertical-v1")
    .forEach((timeline) => {

      const items = timeline.querySelectorAll(".wp-block-accordion-item");
      if (!items.length) return;

      const MIN_PROGRESS = 0;
      const MAX_PROGRESS = 130;

      let currentProgress = MIN_PROGRESS;
      let targetProgress = MIN_PROGRESS;
      let ticking = false;


      function getScrollProgress() {
        const rect = timeline.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        const start = windowHeight * 0.4;
        const end = rect.height - windowHeight * 0.4;

        const progress = ((start - rect.top) / end) * 100;

        return Math.min(100, Math.max(0, progress));
      }


      function updateTarget() {
        targetProgress = getScrollProgress();
        updateActiveItems(targetProgress);

        if (!ticking) {
          requestAnimationFrame(animate);
          ticking = true;
        }
      }

      function animate() {
        const ease = 0.4;
        currentProgress += (targetProgress - currentProgress) * ease;
        timeline.style.setProperty("--progress", `${currentProgress}%`);

        if (Math.abs(targetProgress - currentProgress) > 0.05) {
          requestAnimationFrame(animate);
        } else {
          ticking = false;
        }
      }

      function updateActiveItems(progress) {
        const totalItems = items.length;
        const normalized = progress / 100;

        let activeCount = Math.ceil(normalized * totalItems);

        activeCount = Math.min(totalItems, activeCount);

        items.forEach((item, index) => {
          item.classList.toggle("is-active", index < activeCount);
        });
      }


      window.addEventListener("scroll", updateTarget, {
        passive: true,
      });
      window.addEventListener("resize", updateTarget);

      updateTarget();
    });
})();
